// src/api/client.js
import axios from 'axios';
import { HOST_API } from 'src/config-global';

export const api = axios.create({
  baseURL: HOST_API,
  withCredentials: true,
  headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
});

// Intercepteur requêtes : avant POST/PUT/PATCH/DELETE, s’assurer que le cookie CSRF existe
api.interceptors.request.use(async (config) => {
  const m = (config.method || 'get').toLowerCase();
  const needsCsrf = ['post', 'put', 'patch', 'delete'].includes(m);
  const hasXsrf = typeof document !== 'undefined' && document.cookie.includes('XSRF-TOKEN=');

  if (needsCsrf && !hasXsrf) {
    await api.get('/sanctum/csrf-cookie'); // pose XSRF-TOKEN + laravel_session
  }
  return config;
});

// Intercepteur réponses : retry 419 une fois, sinon signaler AUTH_REQUIRED
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const response = error && error.response;
    const config = error && error.config;

    // Pas de réponse => souci réseau
    if (!response) {
      error.code = 'NETWORK';
      return Promise.reject(error);
    }

    // 419 = CSRF expiré → tenter un refresh 1 fois puis rejeter
    if (response.status === 419 && config && !config.__retriedCsrf) {
      try {
        await api.get('/sanctum/csrf-cookie');
        config.__retriedCsrf = true;
        return api.request(config);
      } catch (e) {
        e.code = 'AUTH_REQUIRED';
        return Promise.reject(e);
      }
    }

    // 401 (non auth) ou 419 après retry → laisser le caller décider (logout, redirection, etc.)
    if (response.status === 401 || response.status === 419) {
      error.code = 'AUTH_REQUIRED';
    }

    return Promise.reject(error);
  }
);
